import script from "./KanbanLanes.vue?vue&type=script&setup=true&lang=js"
export * from "./KanbanLanes.vue?vue&type=script&setup=true&lang=js"

import "./KanbanLanes.vue?vue&type=style&index=0&id=5de06ad7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de06ad7"]])

export default __exports__